import React from 'react';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { UsageItem } from '@vfgroup-oneplatform/foundation/Components';

import { getPlaceholdersBasedOnUsageType, getUsageProperColor } from '../../../Utils/Getter';
import UsageCard from '../UsageCard';

import styles from './PercentageUsageCard.Styles';

function PercentageUsageCard({
  title,
  date,
  usageData,
  renderHeaderRightSection,
  containerStyle,
  images,
  ...props
}) {
  return (
    <UsageCard
      title={title}
      renderHeaderRightSection={renderHeaderRightSection}
      date={date}
      containerStyle={containerStyle}
    >
      {_map(usageData, usageItem => {
        const {
          usageType,
          icon,
          isUnlimited,
          valuePercentage,
          remainingAmount: amount,
          remainingUnits: units,
        } = usageItem;

        const percentageColor = getUsageProperColor(usageType);

        return (
          <UsageItem
            percentageIndicatorSecondaryColor={percentageColor}
            percentageIndicatorContainerStyle={styles.percentageIndicatorContainerStyle}
            containerStyle={styles.itemContainerStyle}
            usageItemLabel={usageType}
            icon={icon}
            isUnlimitedUsage={isUnlimited}
            usageValuesTextStyle={{ color: percentageColor }}
            usageValuesPlaceholders={getPlaceholdersBasedOnUsageType({
              ...usageItem,
              amount,
              units,
            })}
            usageValuesText={'soho_usage_usage_card_consumption'}
            unlimitedUsageText="soho_usage_usage_card_unlimited_consumption"
            usagePercentageValue={valuePercentage}
            shouldShowAddUsageButton={false}
            {...usageItem}
            images={images}
          />
        );
      })}
    </UsageCard>
  );
}

PercentageUsageCard.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  usageData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      usageType: PropTypes.string,
      icon: PropTypes.string,
      isUnlimited: PropTypes.bool,
      usedAmount: PropTypes.number,
      usedUnits: PropTypes.string,
      remainingAmount: PropTypes.number,
      remainingUnits: PropTypes.string,
      totalAmount: PropTypes.number,
      totalUnits: PropTypes.string,
      valuePercentage: PropTypes.string,
    }),
  ),
  renderHeaderRightSection: PropTypes.func,
  containerStyle: ViewPropTypes.style,
  images: PropTypes.object,
};

export default PercentageUsageCard;
